import createPersistedState from 'vuex-persistedstate'

export default store => {
  return createPersistedState({
    paths: ['favorites.vehicles']
  })(store)
}
